import React from "react";
import HandleLightcones from "../Handle/HandleLightcones";

function Lightcones() {
  return <HandleLightcones />;
}

export default Lightcones;
